export type SocialPlatform = 'facebook' | 'youtube' | 'spotify' | 'tiktok' | 'instagram' | 'linkedin' | 'x' | 'website' | 'other'

const PLATFORM_LABELS: Record<SocialPlatform, string> = {
  facebook: 'Facebook',
  youtube: 'YouTube',
  spotify: 'Spotify',
  tiktok: 'TikTok',
  instagram: 'Instagram',
  linkedin: 'LinkedIn',
  x: 'X',
  website: 'Website',
  other: 'Other',
}

export const SOCIAL_PLATFORMS = Object.keys(PLATFORM_LABELS) as SocialPlatform[]

export function platformLabel(platform: SocialPlatform) {
  return PLATFORM_LABELS[platform] ?? PLATFORM_LABELS.other
}

export function inferPlatform(value = '', href = ''): SocialPlatform {
  const text = `${value} ${href}`.toLowerCase()
  if (text.includes('facebook') || text.includes('fb.com')) return 'facebook'
  if (text.includes('youtube') || text.includes('youtu.be')) return 'youtube'
  if (text.includes('spotify')) return 'spotify'
  if (text.includes('tiktok')) return 'tiktok'
  if (text.includes('instagram')) return 'instagram'
  if (text.includes('linkedin')) return 'linkedin'
  if (text.includes('twitter.com') || text.includes('x.com')) return 'x'
  if (text.includes('http') || text.includes('www.')) return 'website'
  return 'other'
}

export default function PlatformIcon({ platform, className }: { platform: SocialPlatform; className?: string }) {
  const props = { viewBox: '0 0 24 24', 'aria-hidden': true, focusable: false, className }
  if (platform === 'youtube') {
    return (
      <svg {...props}>
        <rect x="4" y="6" width="16" height="12" rx="3" />
        <path d="M10 9l5 3-5 3z" />
      </svg>
    )
  }
  if (platform === 'spotify') {
    return (
      <svg {...props}>
        <circle cx="12" cy="12" r="8" />
        <path d="M8 10.2c2.8-.8 5.7-.5 8.1.8" />
        <path d="M8.8 13c2-.5 4.2-.3 6 .7" />
        <path d="M9.5 15.5c1.3-.3 2.7-.1 4 .5" />
      </svg>
    )
  }
  if (platform === 'tiktok') {
    return (
      <svg {...props}>
        <path d="M14 5v9.4a4 4 0 1 1-3.2-3.9" />
        <path d="M14 5c.8 2.6 2.4 4 5 4.4" />
      </svg>
    )
  }
  if (platform === 'instagram') {
    return (
      <svg {...props}>
        <rect x="5" y="5" width="14" height="14" rx="4" />
        <circle cx="12" cy="12" r="3.2" />
        <path d="M16.4 8h.1" />
      </svg>
    )
  }
  if (platform === 'facebook') {
    return (
      <svg {...props}>
        <path d="M14 8h3V5h-3.4c-3 0-4.6 1.8-4.6 4.8V12H6v3h3v5h3.3v-5h3.1l.6-3h-3.7V9.8c0-1.1.5-1.8 1.7-1.8z" />
      </svg>
    )
  }
  if (platform === 'linkedin') {
    return (
      <svg {...props}>
        <rect x="5" y="9" width="3" height="10" rx="1" />
        <circle cx="6.5" cy="6.5" r="1.5" />
        <path d="M11 19v-6.2c0-2.2 1.5-3.8 3.6-3.8 2.5 0 4.4 1.7 4.4 5v5h-3v-4.6c0-1.5-.7-2.4-1.9-2.4-1.1 0-2.1.9-2.1 2.4V19z" />
      </svg>
    )
  }
  if (platform === 'x') {
    return (
      <svg {...props}>
        <path d="M6 5l12 14" />
        <path d="M18 5L6 19" />
      </svg>
    )
  }
  if (platform === 'website') {
    return (
      <svg {...props}>
        <circle cx="12" cy="12" r="8" />
        <path d="M4 12h16" />
        <path d="M12 4c2 2.3 3 5 3 8s-1 5.7-3 8" />
        <path d="M12 4c-2 2.3-3 5-3 8s1 5.7 3 8" />
      </svg>
    )
  }
  return (
    <svg {...props}>
      <circle cx="12" cy="12" r="8" />
      <path d="M9 12h6" />
      <path d="M12 9v6" />
    </svg>
  )
}
